import { cn } from '@bridebook/aura';
import { forwardRef, type ComponentPropsWithoutRef, ElementRef } from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

export type SwitchProps = ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>;

export const Switch = forwardRef<ElementRef<typeof SwitchPrimitive.Root>, SwitchProps>(
  ({ className, disabled, ...props }, ref) => (
    <SwitchPrimitive.Root
      ref={ref}
      data-slot="switch"
      className={cn(
        // Base
        'group focus-visible:border-ring inline-flex h-[1.5rem] w-10 shrink-0 items-center rounded-full border border-transparent bg-space-15 p-1 shadow-xs transition-all outline-none focus-visible:ring-[3px] focus-visible:ring-focus-ring',
        // Checked
        'data-[state=checked]:bg-indigo-crush',
        // Disabled
        'disabled:cursor-not-allowed data-[state=checked]:disabled:bg-indigo-crush/40',
        className,
      )}
      disabled={disabled}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          // Base
          'block size-4 translate-x-0 rounded-full bg-white ring-0 transition-transform',
          // Checked
          'data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=checked]:bg-indigo-crush-20',
          // Disabled
          'group-disabled:cursor-not-allowed group-disabled:data-[state=unchecked]:bg-space-08',
        )}
      />
    </SwitchPrimitive.Root>
  ),
);
Switch.displayName = SwitchPrimitive.Root.displayName;
